import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Filters
  customers: [],
  dcs: [],

  // Section data
  summary: null,
  skuVerification: null,
  qcLabor: null,
  edn: null,
  inventoryVariance: null,

  // UI state
  loading: false,
  saving: false,
  error: null,
  filtersLoaded: false,
};

export const valueDashboardSlice = createSlice({
  name: "valueDashboard",
  initialState,
  reducers: {
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    setDcs: (state, action) => {
      state.dcs = action.payload;
    },
    setSummary: (state, action) => {
      state.summary = action.payload;
    },
    setSkuVerification: (state, action) => {
      state.skuVerification = action.payload;
    },
    setQcLabor: (state, action) => {
      state.qcLabor = action.payload;
    },
    setEdn: (state, action) => {
      state.edn = action.payload;
    },
    setInventoryVariance: (state, action) => {
      state.inventoryVariance = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSaving: (state, action) => {
      state.saving = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFiltersLoaded: (state, action) => {
      state.filtersLoaded = action.payload;
    },
    clearDashboard: () => initialState,
  },
});

export const {
  setCustomers,
  setDcs,
  setSummary,
  setSkuVerification,
  setQcLabor,
  setEdn,
  setInventoryVariance,
  setLoading,
  setSaving,
  setError,
  setFiltersLoaded,
  clearDashboard,
} = valueDashboardSlice.actions;

export default valueDashboardSlice.reducer;
